module.exports = "/_next/static/resources/single-8aed8e02f63fbadf3d025f703d77d641.jpg";